import React from 'react';
import { Chip, useMediaQuery } from '@mui/material';
import { Close } from '../../../components/icons';
import IconReusable from '../../../components/IconReusable';

const CustomChip = ({
  label,
  onDelete,
  variant = 'filled', // 'filled' or 'outlined'
  size = 'small',
  color = 'primary',
  deleteIcon,
  sx = {},
  ...props
}) => {
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const getChipStyles = () => {
    const baseStyles = {
      borderRadius: '8px !important',
      padding: '6px 12px',
      height: {xs: '28px', md: '32px'},
      fontSize: {sx: '13px', md: '16px'},
      fontWeight: 600,
      transition: 'all 0.2s ease-in-out',
      '& .MuiChip-deleteIcon': {
        fontSize: { xs: "16px", md: '24px'},
        transition: 'color 0.2s ease-in-out',
        marginLeft: '8px',
        marginRight: '-6px',
      },
      '& .MuiChip-label': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    };

    if (variant === 'filled') {
      return {
        ...baseStyles,
        backgroundColor: '#333333 !important',
        color: '#fff !important',
        border: 'none',
        boxShadow: `
          0px 2px 1px -1px #00000033,
          0px 1px 1px 0px  #00000024,
          0px 1px 2px 0px  #0000001A
        `,
        '& .MuiChip-deleteIcon': {
          ...baseStyles['& .MuiChip-deleteIcon'],
          color: '#fff !important',
        },
        '& .MuiChip-deleteIcon:hover': {
          color: '#fff !important',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
        },
        '&:hover': {
          backgroundColor: '#444444 !important',
        },
        '&:focus': {
          backgroundColor: '#333333 !important',
        },
      };
    }

    // outlined variant
    return {
      ...baseStyles,
      backgroundColor: 'transparent !important',
      color: '#333333 !important',
      border: '1px solid #8C8C8C',
      
      '& .MuiChip-deleteIcon': {
        ...baseStyles['& .MuiChip-deleteIcon'],
        color: '#666666 !important',
      },
      '& .MuiChip-deleteIcon:hover': {
        color: '#333333 !important',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: '50%',
      },
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.03) !important',
        borderColor: '#B8B8B8',
      },
    };
  };

  const defaultDeleteIcon = deleteIcon || (
    <IconReusable name="Close" size={isMobile ? 16 : 24} />
  );

  return (
    <Chip
      label={label}
      onDelete={onDelete}
      size={size}
      variant="outlined" // Always use outlined as base, styling handles the appearance
      color={color}
      deleteIcon={defaultDeleteIcon}
      sx={{
        ...getChipStyles(),
        ...sx,
      }}
      {...props}
    />
  );
};

export default CustomChip;